import { Component, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import { Store } from '@ngrx/store';
import { map } from 'rxjs';

import { ImageResponse } from '@app/api/marketplace/models';
import { environment } from '@environments/environment';
import { ProductSearchResponseWithAmount } from '@search/interfaces/product-search-response-with-amount.interface';
import { ProductSearchSelectors } from '@search/store/search.slice';
import { SwiperImage } from '@shared/components/image-swiper/image-swiper.component';

@Component({
  selector: 'app-search-product-modal',
  templateUrl: './search-product-modal.component.html',
  styleUrls: ['./search-product-modal.component.scss'],
})
export class SearchProductModalComponent {
  readonly imageBaseUrl = `${environment.imageStorageUrl}`;
  activeIndex = 0;

  product$ = this.store.select(ProductSearchSelectors.selectActiveProduct);
  logoImages$ = this.product$.pipe(
    map((product) =>
      product?.suppliers?.map(
        (supplier) =>
          ({
            url:
              this.imageBaseUrl + '/merchants/' + supplier.merchantId + '/logo',
            alt: supplier.name,
          } as SwiperImage)
      )
    )
  );

  get activeImage(): ImageResponse | undefined {
    return (this.data.product.images as Array<ImageResponse>)[this.activeIndex];
  }

  constructor(
    public dialogRef: MatDialogRef<SearchProductModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      product: ProductSearchResponseWithAmount;
    },
    private store: Store
  ) {}

  prevImage() {
    this.activeIndex =
      this.activeIndex > 0
        ? this.activeIndex - 1
        : this.data.product.images!.length - 1;
  }

  nextImage() {
    this.activeIndex =
      (this.activeIndex + 1) % this.data.product.images!.length;
  }
}
